import { useMemo } from 'react';

export const useFormattedDate = (date, format, _deps = []) => {
  return useMemo(() => {
    return new Intl.DateTimeFormat('fr-FR', format).format(date);
  }, [date, format]);
};
